import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers } from "vue";
import { computed, ref, onBeforeMount } from '../../../adapter-vue';
import dayjs, { Dayjs } from 'dayjs';
import { TUITranslateService } from '@tencentcloud/chat-uikit-engine';
import DateTable from './date-table.vue';
import Icon from '../Icon.vue';
import leftArrowIcon from '../../../assets/icon/left-arrow.svg';
import rightArrowIcon from '../../../assets/icon/right-arrow.svg';
import dLeftArrowIcon from '../../../assets/icon/d-left-arrow.svg';
import dRightArrowIcon from '../../../assets/icon/d-right-arrow.svg';
import { isPC } from '../../../utils/env';
export default /*@__PURE__*/_defineComponent({
  __name: 'date-picker-panel',
  props: {
    type: {
      type: String,
      default: 'range' // "single"/"range"
    },
    // type 为 single 时特有属性
    date: {
      type: Dayjs,
      default: () => dayjs()
    },
    // type 为 range 时特有属性
    startDate: {
      type: Dayjs,
      default: null
    },
    endDate: {
      type: Dayjs,
      default: null
    },
    rangeType: {
      type: String,
      default: '' // "left"/"right"
    },
    currentOtherPanelValue: {
      type: Dayjs,
      default: null
    }
  },
  emits: ['pick', 'change'],
  setup(__props, _ref) {
    var {
      emit: __emit
    } = _ref;
    var props = __props;
    var emit = __emit;
    var n = className => {
      return className ? ['tui-date-picker-panel-' + className, !isPC && 'tui-date-picker-panel-h5-' + className] : ['tui-date-picker-panel', !isPC && 'tui-date-picker-panel-h5'];
    };
    var currentPanelDate = ref();
    var year = computed(() => {
      var _currentPanelDate$val;
      return (_currentPanelDate$val = currentPanelDate.value) === null || _currentPanelDate$val === void 0 ? void 0 : _currentPanelDate$val.get('year');
    });
    var month = computed(() => {
      var _currentPanelDate$val2;
      return (_currentPanelDate$val2 = currentPanelDate.value) === null || _currentPanelDate$val2 === void 0 ? void 0 : _currentPanelDate$val2.format('MMMM');
    });
    var canYearMore = computed(() => {
      var _props$currentOtherPa, _props$currentOtherPa2, _currentPanelDate$val3;
      var prevYearNumber = ((_props$currentOtherPa = props.currentOtherPanelValue) === null || _props$currentOtherPa === void 0 ? void 0 : _props$currentOtherPa.year()) - 1;
      var prevYear = (_props$currentOtherPa2 = props.currentOtherPanelValue) === null || _props$currentOtherPa2 === void 0 ? void 0 : _props$currentOtherPa2.year(prevYearNumber);
      return props.rangeType === 'right' || ((_currentPanelDate$val3 = currentPanelDate.value) === null || _currentPanelDate$val3 === void 0 ? void 0 : _currentPanelDate$val3.isBefore(prevYear, 'year'));
    });
    var canMonthMore = computed(() => {
      var _props$currentOtherPa3, _props$currentOtherPa4, _currentPanelDate$val4;
      var prevMonthNumber = ((_props$currentOtherPa3 = props.currentOtherPanelValue) === null || _props$currentOtherPa3 === void 0 ? void 0 : _props$currentOtherPa3.month()) - 1;
      var prevMonth = (_props$currentOtherPa4 = props.currentOtherPanelValue) === null || _props$currentOtherPa4 === void 0 ? void 0 : _props$currentOtherPa4.month(prevMonthNumber);
      return props.rangeType === 'right' || ((_currentPanelDate$val4 = currentPanelDate.value) === null || _currentPanelDate$val4 === void 0 ? void 0 : _currentPanelDate$val4.isBefore(prevMonth, 'month'));
    });
    var canYearLess = computed(() => {
      var _props$currentOtherPa5, _props$currentOtherPa6, _currentPanelDate$val5;
      var nextYearNumber = ((_props$currentOtherPa5 = props.currentOtherPanelValue) === null || _props$currentOtherPa5 === void 0 ? void 0 : _props$currentOtherPa5.year()) + 1;
      var nextYear = (_props$currentOtherPa6 = props.currentOtherPanelValue) === null || _props$currentOtherPa6 === void 0 ? void 0 : _props$currentOtherPa6.year(nextYearNumber);
      return props.rangeType === 'left' || ((_currentPanelDate$val5 = currentPanelDate.value) === null || _currentPanelDate$val5 === void 0 ? void 0 : _currentPanelDate$val5.isAfter(nextYear, 'year'));
    });
    var canMonthLess = computed(() => {
      var _props$currentOtherPa7, _props$currentOtherPa8, _currentPanelDate$val6;
      var nextMonthNumber = ((_props$currentOtherPa7 = props.currentOtherPanelValue) === null || _props$currentOtherPa7 === void 0 ? void 0 : _props$currentOtherPa7.month()) + 1;
      var nextMonth = (_props$currentOtherPa8 = props.currentOtherPanelValue) === null || _props$currentOtherPa8 === void 0 ? void 0 : _props$currentOtherPa8.month(nextMonthNumber);
      return props.rangeType === 'left' || ((_currentPanelDate$val6 = currentPanelDate.value) === null || _currentPanelDate$val6 === void 0 ? void 0 : _currentPanelDate$val6.isAfter(nextMonth, 'month'));
    });
    // range 判断：
    // 前提，如果只有一个，那一定是start
    // 如果有startDate
    // left所在界面首次展示startDate所在month/year
    // 如果有startDate && endDate
    // 如果在同一个月
    // 均在left展示，right展示下一个月
    // 如果不在同个月
    // start在left展示，end在right展示
    // 即要判断start和end是否在同一个月
    // 如果都没有 left展示当前月 right展示下一个月
    var handleSingleDate = () => {
      var _dayjs;
      if (props.date && (_dayjs = dayjs(props.date)) !== null && _dayjs !== void 0 && _dayjs.isValid()) {
        // props.date year and month
        return {
          date: props === null || props === void 0 ? void 0 : props.date
        };
      }
      // nowadays year and month
      return {
        date: dayjs()
      };
    };
    var handleRangeDate = () => {
      var _props$endDate;
      // 计算左边
      switch (props.rangeType) {
        case 'left':
          if (props.startDate && dayjs.isDayjs(props.startDate)) {
            return {
              date: props === null || props === void 0 ? void 0 : props.startDate
            };
          } else {
            return {
              date: dayjs()
            };
          }
        case 'right':
          if (props.endDate && dayjs.isDayjs(props.endDate) && props !== null && props !== void 0 && (_props$endDate = props.endDate) !== null && _props$endDate !== void 0 && _props$endDate.isAfter(props.startDate, 'month')) {
            return {
              date: props === null || props === void 0 ? void 0 : props.endDate
            };
          } else {
            var _month = (props.startDate || dayjs()).month();
            return {
              date: (props.startDate || dayjs()).month(_month + 1)
            };
          }
        default:
          return {
            date: dayjs()
          };
      }
    };
    function handlePick(cell) {
      emit('pick', cell);
    }
    // 统一处理日期切换
    function change(type, num) {
      currentPanelDate.value = dayjs(currentPanelDate.value.toDate()).add(num, type);
      emit('change', currentPanelDate.value);
    }
    onBeforeMount(() => {
      switch (props.type) {
        case 'single':
          currentPanelDate.value = handleSingleDate().date;
          emit('change', currentPanelDate.value);
          break;
        case 'range':
          currentPanelDate.value = handleRangeDate().date;
          emit('change', currentPanelDate.value);
          break;
      }
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass([n('')]),
        onMouseup: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"]))
      }, [_createElementVNode("div", {
        class: _normalizeClass([n('body')])
      }, [_createElementVNode("div", {
        class: _normalizeClass([n('body-header')])
      }, [_createElementVNode("div", {
        class: _normalizeClass([n('body-header-prev')])
      }, [_unref(canYearLess) ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass([n('icon')]),
        onClick: _cache[0] || (_cache[0] = $event => change('year', -1))
      }, [_createVNode(Icon, {
        file: _unref(dLeftArrowIcon),
        width: '12px',
        height: '12px'
      }, null, 8, ["file"])], 2)) : _createCommentVNode("", true), _unref(canMonthLess) ? (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: _normalizeClass([n('icon')]),
        onClick: _cache[1] || (_cache[1] = $event => change('month', -1))
      }, [_createVNode(Icon, {
        file: _unref(leftArrowIcon),
        width: '10px',
        height: '10px'
      }, null, 8, ["file"])], 2)) : _createCommentVNode("", true)], 2), _createElementVNode("div", {
        class: _normalizeClass([n('body-header-label')])
      }, [_createElementVNode("div", {
        class: _normalizeClass([n('body-header-label-item')])
      }, _toDisplayString(_unref(year)), 3), _createElementVNode("div", {
        class: _normalizeClass([n('body-header-label-item')])
      }, _toDisplayString(_unref(TUITranslateService).t("time.".concat(_unref(month)))), 3)], 2), _createElementVNode("div", {
        class: _normalizeClass([n('body-header-next')])
      }, [_unref(canMonthMore) ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass([n('icon')]),
        onClick: _cache[2] || (_cache[2] = $event => change('month', 1))
      }, [_createVNode(Icon, {
        file: _unref(rightArrowIcon),
        width: '10px',
        height: '10px'
      }, null, 8, ["file"])], 2)) : _createCommentVNode("", true), _unref(canYearMore) ? (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: _normalizeClass([n('icon')]),
        onClick: _cache[3] || (_cache[3] = $event => change('year', 1))
      }, [_createVNode(Icon, {
        file: _unref(dRightArrowIcon),
        width: '12px',
        height: '12px'
      }, null, 8, ["file"])], 2)) : _createCommentVNode("", true)], 2)], 2), _createElementVNode("div", {
        class: _normalizeClass([n('body-content')])
      }, [_createVNode(DateTable, {
        type: props.type,
        date: props.date,
        startDate: props.startDate,
        endDate: props.endDate,
        currentPanelDate: _unref(currentPanelDate),
        onPick: handlePick
      }, null, 8, ["type", "date", "startDate", "endDate", "currentPanelDate"])], 2)], 2)], 34);
    };
  }
});